import { BaseException } from "@/exceptions/base-exception.exception"
import { ExceptionWeights } from "@/enums/exceptions/exception-weights"

export class GeneralValidationException extends BaseException {
  exceptionId = "general-validation-exception"
  title = "Validatiefout"
  weight = ExceptionWeights.ERROR
  errorMessage = "Er ging iets mis bij het valideren van de gegevens."

  constructor(errorMessage?: string) {
    super()
    this.errorMessage = errorMessage || this.errorMessage
  }

  public getMessage() {
    return this.errorMessage
  }
}
